export default __webpack_public_path__ + "static/media/img_text.883b65d0.svg";